export default __webpack_public_path__ + "static/TOY7024_V01_384x592-61b8ada286191ff59ee045ae2453040a.jpg";